'use client'
import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

type PaginationCardProps = {
  imageUrl?: string
  title?: string
  description?: string
  publishDate?: string
  categoryName?: string
  link?: string
  isLoading?: boolean
}

const PaginationCard: React.FC<PaginationCardProps> = ({
  imageUrl = '',
  title = '',
  description = '',
  publishDate = '',
  categoryName = '',
  link = '',
  isLoading = false,
}) => {
  // Hàm format ngày giờ theo định dạng yêu cầu
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleString('vi-VN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
  }

  if (isLoading) {
    // Skeleton khi đang tải
    return (
      <article className="flex border-b border-gray-300 pb-4 mb-4">
        {/* Skeleton cho hình ảnh */}
        <div className="w-1/3 h-[200px] pr-4">
          <div className="w-full h-full bg-gray-300 animate-pulse" />
        </div>

        {/* Skeleton cho nội dung */}
        <div className="flex-1 space-y-4">
          <div className="h-4 bg-gray-300 animate-pulse rounded w-1/3" />
          <div className="h-6 bg-gray-300 animate-pulse rounded w-3/4" />
          <div className="h-4 bg-gray-300 animate-pulse rounded w-full" />
          <div className="h-4 bg-gray-300 animate-pulse rounded w-5/6" />
          <div className="h-4 bg-gray-300 animate-pulse rounded w-2/3 mt-3" />
        </div>
      </article>
    )
  }

  return (
    <article className="flex border-b border-gray-300 pb-4 mb-4">
      {/* Phần hình ảnh bên trái */}
      <Link href={`/${link}`} className="w-1/3 md:h-[200px] h-[120px] pr-4">
        <Image
          src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${imageUrl}`}
          alt={title || 'title '}
          width={150}
          height={150}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 680px"
          className="w-full h-full object-cover"
        />
      </Link>

      {/* Phần tiêu đề và mô tả bên phải */}
      <div className="flex-1">
        <div className="text-sm text-gray-500">
          <span>{formatDate(publishDate)}</span>
        </div>
        {/* Hiển thị thể loại và ngày giờ trước tiêu đề */}
        <div className="text-primary font-semibold">
          <span>{categoryName} </span>
        </div>

        {/* Tiêu đề bài viết */}
        <Link href={`/${link}`}>
          <h3 className="text-lg font-title font-semibold text-gray-800 hover:text-primary transition duration-200 mt-2">
            {title}
          </h3>
        </Link>

        {/* Mô tả bài viết */}
        <p className="text-sm text-gray-600 mt-2 line-clamp-3 lg:line-clamp-4 xl:line-clamp-5 hidden lg:block">
          {description}
        </p>

        {/* Hiển thị số lượt xem */}
        {/* <div className="flex items-center gap-2 text-xs text-gray-500 mt-3">
          <FontAwesomeIcon icon={faEye} />
          <span>{viewCount} Views</span>
        </div> */}
      </div>
    </article>
  )
}

export default PaginationCard
